import * as globalFeed from "./globalFeed"
import * as adminFeed from "./adminFeed"
import * as airTrafficView from "./views/globalAirTraffic"
import * as globalGrsMarkers from './views/globalGrsMarkers'
import * as SkylineAPI from "./skylineApi"
import * as feather from "feather-icons"
import Navigo from 'navigo'

import "leaflet.control.layers.tree"

// css imports
import "../css/normalize.css"
import "../css/skeleton.css"
import "../css/leaflet-velocity.min.css"
import "leaflet.control.layers.tree/L.Control.Layers.Tree.css"
import "notyf/notyf.min.css"
import "../css/mission.css"
import "../css/skyline.css"

// Routes
import indexRoute from "./routes/index"
import missionsRoute from './routes/missions'
import missionRoute from './routes/mission'
import devicesRoute from './routes/devices'
import deviceRoute from './routes/device'
import newDeviceRoute from "./routes/newDevice"
import newMissionRoute from "./routes/newMission"

import { byId } from "./utils"
import { applyRoles, prepareRoleSwitcher } from "./auth"

async function startApp() {
  initializeMap()
  await SkylineAPI.getToken()
  await SkylineAPI.loadDevices()
  await SkylineAPI.loadMissions()
  await globalFeed.connect(window.skyline.env.BASE_URL)
  airTrafficView.setup(globalFeed)
  globalGrsMarkers.setup()
  await adminFeed.connect(window.skyline.env.BASE_URL)
}

startApp().then(() => {
  const router = new Navigo('/')

  router.hooks({
    after(match) {
      const elements = document.querySelectorAll('[data-navigo-nav]')
      elements.forEach(e => e.classList.remove('active'))
      const path = '/' + match.url
      for (const e of elements) {
        const exact = e.dataset && e.dataset.navigoNav && e.dataset.navigoNav == 'exact'
        if (e.pathname && (path === e.pathname || (!exact && path.includes(e.pathname)))) {
          e.classList.add('active')
        }
      }

      feather.replace()
    }
  })

  const app = {
    router,
    root: byId('root'),
    setContent: (content, leaveHook)=> {
      if (app.leaveHook) {
        app.leaveHook()
      }
      app.leaveHook = leaveHook
      while(app.root.firstChild) {
        app.root.removeChild(app.root.firstChild)
      }
      const appended = app.root.appendChild(content)
      feather.replace()
      applyRoles()
      return appended
    },
  }

  indexRoute(app)
  missionsRoute(app)
  newMissionRoute(app)
  missionRoute(app)
  devicesRoute(app)
  newDeviceRoute(app)
  deviceRoute(app)

  router.resolve()

  prepareRoleSwitcher()

  window.app = app
})